var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"GuestSearch_main"}},[_c('FilterFrame',{ref:"filter",attrs:{"filter-form":_vm.guestSearchFilter},on:{"search":_vm.handleSearch,"clear":function($event){return _vm.clearSearch()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }